import { forwardRef, createElement } from 'react';

function IconArrowLeft(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M11.03 7.97a.75.75 0 01.073.976l-.073.084-2.219 2.219L17 11.25a.75.75 0 01.102 1.493L17 12.75l-8.19-.001 2.22 2.22a.75.75 0 01-.976 1.134l-.084-.073-3.5-3.5-.08-.094-.051-.081-.05-.116-.027-.103-.01-.089v-.094l.018-.124.03-.099.047-.099.054-.082.069-.08 3.5-3.5a.75.75 0 011.06 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ArrowLeft = /*#__PURE__*/forwardRef(IconArrowLeft);

export default ArrowLeft;
//# sourceMappingURL=ArrowLeft.js.map
